import React, { useEffect, useState } from 'react'
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MenuButtons from '../../components/MenuButtons';

function Contact() {

    document.title = "Altcoinator | Contact";

    
    
     return ( 
        <>
        <div id="wrapper">
          <Header />

          <section className="tf-section tf-wallet"  >
            <div style={{maxWidth:"760px"}} className="container">
              <div className="row">
                <div className="col-md-12">
                      <div className="wallet-form">
                        <MenuButtons/>
                            <hr/>
                                <h4>Contact</h4>
                                You can contact us with the accounts below
                            <hr/>
                         <div style={{textAlign:"left"}}>
                            <h6>
                           Twitter: <a href='https://twitter.com/altcoinatorcom' target='_blank'>Go Twitter</a> <br/>
                           Email: <a href='mail:altcoinator@yandex.com'>altcoinator@yandex.com</a> <br/>
                           </h6>
                            
                            
                         </div>

                      </div>
                </div>
               </div>
             </div>
            </section>
          <Footer/>
        </div>
      </> 
  ); 

} 

export default Contact;